import React, { useRef } from 'react'
import { motion } from 'framer-motion'

const modalVariant = {
	hidden: {
		y: "-40vh",
		opacity: 0
	},
	visible: {
		opacity: 1,
		y: "20vh",
		transition: {
			// duration:0.2,
			type: "spring",
			mass: 0.4
		}
	}
}
const overlayVariant = {
	visible: {
		transition: {
			when: "beforeChildren"
		}
	}
}
export default function Modal({ showModal, setShowModal }) {
	const commentRef = useRef('')
	const emailRef = useRef('')
	const fnameRef = useRef('')
	const lnameRef = useRef('')
	async function handleComment(e) {
		e.preventDefault()
		fetch("https://gagnu-personal-server.vercel.app/api/v1/feeds", {
			method: "POST",
			headers: {
				"X-API-Key": "gpf_live_XhE6yYW26hroMCTPofxw25yHR1vfd3R2aZKUOdWIVRQ",
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				comment: commentRef.current.value,
				email: emailRef.current.value,
				firstName: fnameRef.current.value,
				lastName: lnameRef.current.value
			})
		})
			.then(response => response.json())
			.then(json => console.log(json))
			.catch(error => console.log(error))
		setShowModal(false)
	}
	if (!showModal) return null
	return (
		<motion.div className="overlay-modal"
			exit={{ opacity: 0 }}
			variants={overlayVariant}
			animate="visible"
		>
			<motion.div className="content" variants={modalVariant} animate="visible" initial="hidden">
				<span className="overlay-close" onClick={() => setShowModal(false)}>close</span>
				<h4 className="mt-4 text-primary"><strong>Hurey! you are almost there</strong></h4>
				<p>If you liked this app, plese leave a comment below</p>
				<form onSubmit={handleComment}>
					<input type="email" ref={emailRef} placeholder="email" required /><br />
					<div style={{ display: 'flex', margin: "10px auto", gap: "10px", justifyContent: "space-between" }}>
						<input type="text" ref={fnameRef} placeholder="first name" required /><br />
						<input type="text" ref={lnameRef} placeholder="last name" required /><br />
					</div>
					<input type="text" ref={commentRef} placeholder="comment" required /><br />
					<button className="btn-primary btn-block rounded mt-2">Thankyou</button>
				</form>
			</motion.div>
		</motion.div>
	)
}